export default __webpack_public_path__ + "static/media/viewpoint.fd4da7f7.png";